import { createWrittenAccountPreviews } from "./WrittenAccountPreviews";

export const WrittenAccountPreviewsAll = createWrittenAccountPreviews(
	"written_accounts",
	(account) => account.hasBeenActive,
);
